/**
 * 404 页面
 * @author jasonelchen
 */
import React, { FunctionComponent, useEffect } from 'react'
import { useTitle } from '@hooks'
import { sessionStore } from '@store'
import './style.less'
import { ModuleNameMapping } from '@configs/constants'
import { getStaffName } from '@library'

export const NotFoundPage: FunctionComponent<React.PropsWithChildren<{}>> = () => {
  useTitle('404')
  const userInfo = sessionStore(s => s.userInfo)
  useEffect(() => {
  window.XSY_TRACK?.trackClick('error_track', {
    content: {
      belong_module: userInfo?.belongModule,
      belong_module_name: ModuleNameMapping[userInfo?.belongModule],
      follower: getStaffName(userInfo?.salesName, userInfo?.salesNameCh),
      referrer: document.referrer,
      href: window.location.href,
      time: new Date().toLocaleString(),
    },
  })
  }, [])
  return (
    <>
      <img className="warning-image" src="https://cloudcache.tencent-cloud.com/open_proj/proj_qcloud_v2/mc_2014/break/css/errorpage/img/404.png" />
      <h2>该页面暂时无法访问，可能由于网址已删除或没有权限</h2>
      <p className="small-tip">
        您可以前往：
        <a className="helper-link" href="/">首页</a>
      </p>
    </>
  )
}

export default NotFoundPage
